import { useState, useEffect } from "react";
import api from "../../services/api";
import AdminLayout from "../layouts/AdminLayout";
import StatCard from "../components/StatCard";
import PageTitle from "../components/ui/PageTitle";
import {
  BriefcaseBusiness,
  Users,
  UserCog,
  FileText,
  TrendingUp,
} from "lucide-react";
import AnalyticsChart from "../components/AnalyticsChart";
import RecentJobs from "../components/RecentJobs";
import RecentCandidates from "../components/RecentCandidates";

export default function Dashboard() {
  // State for dynamic data
  const [stats, setStats] = useState({
    total_jobs: 0,
    total_candidates: 0,
    total_employees: 0,
    total_applications: 0,
    recent_candidates: [], 
    recent_jobs: [],
    chart_data: []
  });

  // Fetching data from API
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("admin_token");
        
        const res = await api.get("/dashboard", {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        // DEBUG: Console mein check karo kya data aa raha hai
        console.log("Backend API Response:", res.data);
        
        setStats(res.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };
    fetchDashboardData();
  }, []);

  return (
    <AdminLayout>
      {/* Main Container with Off-White Background */}
      <div className="min-h-screen bg-[#FCFCFC] p-4 sm:p-6 lg:p-8 rounded-2xl">
        
        {/* Header Section */}
        <div className="mb-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-6 border-b border-gray-100">
          <div>
            <PageTitle
              title="Dashboard"
              subtitle="Welcome back! Here's what's happening today."
            />
          </div>
          
          {/* Quick Premium Badge */}
          <div className="flex items-center gap-2 bg-[#000000] text-[#FED547] px-4 py-2 rounded-full text-xs font-semibold tracking-wide shadow-sm self-start sm:self-auto">
            <TrendingUp className="w-4 h-4" />
            <span>LIVE PERFORMANCE</span>
          </div>
        </div>

        {/* Top Row: Key Metrics - Now Dynamic */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          <StatCard
            title="Total Jobs"
            value={stats.total_jobs}
            increase="+18%"
            icon={BriefcaseBusiness}
            color="bg-[#000000] text-[#FED547]"
          />
          <StatCard
            title="Candidates"
            value={stats.total_candidates}
            increase="+9%"
            icon={Users}
            color="bg-[#FED547] text-[#000000]"
          />
          <StatCard
            title="Employees"
            value={stats.total_employees}
            increase="+4%"
            icon={UserCog}
            color="bg-[#000000] text-[#FED547]"
          />
          <StatCard
            title="Applications"
            value={stats.total_applications}
            increase="+21%"
            icon={FileText}
            color="bg-[#FED547] text-[#000000]"
          />
        </div>

        {/* Middle/Bottom Row: Analytics and Activity */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
          
          {/* Left Column: Main Analytics */}
          <div className="xl:col-span-2 flex flex-col min-h-[450px] bg-[#FFFFFF] p-6 rounded-2xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-gray-50 hover:shadow-[0_4px_25px_-4px_rgba(254,213,71,0.15)] transition-all duration-300">
            <div className="mb-4">
              <span className="text-xs font-bold uppercase tracking-widest text-gray-400">Overview</span>
              <h3 className="text-lg font-bold text-[#000000]">Analytics Insights</h3>
            </div>
            <div className="flex-1">
              <AnalyticsChart chartData={stats.chart_data} />
            </div>
          </div>

          {/* Right Column: Recent Activity Feed */}
          <div className="flex flex-col gap-8">
            <div className="bg-[#FFFFFF] p-6 rounded-2xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-gray-50">
              <RecentCandidates candidates={stats.recent_candidates} />
            </div>
            <div className="bg-[#FFFFFF] p-6 rounded-2xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-gray-50">
              <RecentJobs jobs={stats.recent_jobs} />
            </div>
          </div>
          
        </div>
      </div>
    </AdminLayout>
  );
}